import { IUserSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IUserTrackingData } from '../../types';

export function createUserTrackingData(abGroup: number, user?: IUserSchema | null): IUserTrackingData {
  if (!user) {
    return notAutorizedUserData(abGroup);
  }

  const { cianUserId, email, ga, realtyUserId: userId } = user;

  const type = (ga && ga.type) || 'not_authorized';

  return {
    abGroup,
    cianUserId,
    email,
    type,
    userId,
  };
}

function notAutorizedUserData(abGroup: number) {
  return { abGroup, type: 'not_authorized' };
}
